import { SCOPES, type SearchScope } from './searchTypes';

// The scope segmented-tabs — the app's .sr-tabs language, for narrowing a broad
// query to one type. The Users tab is hidden for a non-admin (the endpoint is
// admin-only for users; offering a tab that 403s would be a dead end).
export function ScopeTabs({
  scope,
  onScope,
  canSeeUsers,
}: {
  scope: SearchScope;
  onScope: (s: SearchScope) => void;
  canSeeUsers: boolean;
}) {
  const tabs = SCOPES.filter((t) => t.key !== 'user' || canSeeUsers);
  return (
    <div className="gs-scope-row">
      {/* the shared segmented control (.sr-tabs / .sr-tab / .sr-tab.on) */}
      <div className="sr-tabs" role="tablist" aria-label="Filter search by type">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={scope === t.key}
            className={`sr-tab${scope === t.key ? ' on' : ''}`}
            onClick={() => onScope(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}
